// extracted by mini-css-extract-plugin
module.exports = {"text":"Page-module__text___WNFqz Fonts-module__bt___102gf"};